import gql from 'graphql-tag';

export const getCompanyHistories = gql`
  query getCompanyHistories($id: ID!) {
    getCompanyHistories(id: $id) {
      updater
      updatedAt
    }
  }
`;
